import * as yup from 'yup'

export interface VehicleConformityDetailsDto {
  sentToDOTDateTime?: string
  conformityPackageTrackingNumber?: string
  vin?: string
}

export const conformityDetailsValidationSchema = yup.object({
  conformityPackageTrackingNumber: yup
    .string()
    .max(200, 'Conformity Package Tracking # cannot be more than 200 characters.')
    .required('Conformity Package Tracking # is required.')
})
